import {Injectable} from '@angular/core';
import {map, Observable} from 'rxjs';
import {PaginatedResponse, ServiceProviderHub, SingleResponse} from '@generated-backend-types';
import {BaseApiEndpointService} from '../base-endpoint/base-endpoint.service';
import {ListItem} from '../../types/list-item.type';
import EventOverviewSnapshot = ServiceProviderHub.App.Http.Resources.ServiceProviderHub.Eventmanagement.Event.EventOverviewSnapshot.EventOverviewSnapshot;
import Event = ServiceProviderHub.App.Http.Resources.ServiceProviderHub.Eventmanagement.Event.Event;
import EventInquiry = ServiceProviderHub.App.Http.Resources.ServiceProviderHub.Eventmanagement.Event.Inquiry.EventInquiry;
import PendingPdfDownload = ServiceProviderHub.App.Http.Resources.ServiceProviderHub.Eventmanagement.Events.PendingPdfDownload;

@Injectable()
export class EventOverviewSnapshotService extends BaseApiEndpointService<EventOverviewSnapshot> {

  public forEvent(e: Event | string): void {
    const id = typeof e === 'string' ? e : e.id;
    this.endpoint = `/events/${id}/event-overview-snapshots`;
  }

  public export(snapshotId: string): Observable<SingleResponse<PendingPdfDownload>> {
    return this.http.post<SingleResponse<PendingPdfDownload>>(
      `${this.endpoint}/${snapshotId}/export`,
      {},
    );
  }

  public inquiriesForSnapshot(snapshotId: string): Observable<EventInquiry[]> {
    return this.http
      .get<PaginatedResponse<EventInquiry>>(`${this.endpoint}/${snapshotId}/inquiries`)
      .pipe(map(response => response.data));
  }

  public modelToMultiSelectItem(m: EventOverviewSnapshot): ListItem & {model: EventOverviewSnapshot} {
    return {
      id: m.id,
      text: '',
      isDisabled: false,
      model: m,
    };
  }
}
